/**
 * Service d'authentification
 * Gère la connexion, déconnexion et gestion des tokens via Vuex
 */
import apiService from './api.service';
import store from '@/store';

class AuthService {
  /**
   * Connexion utilisateur
   * Note: Le token est maintenant géré par Vuex via l'action setUser
   */
  async login(credentials) {
    const response = await apiService.post('auth/login', credentials);
    // Le token sera stocké dans Vuex par le composant Login.vue
    // via store.dispatch('setUser', userData)
    return response;
  }

  /**
   * Déconnexion utilisateur
   * Nettoie le store Vuex et le sessionStorage
   */
  logout() {
    store.dispatch('destroySession');
  }

  /**
   * Rafraîchir le token
   */
  async refreshToken(refreshToken) {
    const response = await apiService.post('auth/refresh', { refreshToken });
    if (response.token && response.user) {
      // Mettre à jour le token dans Vuex
      store.dispatch('setUser', response.user);
    }
    return response;
  }

  /**
   * Vérifier si l'utilisateur est authentifié
   * Vérifie la présence du token dans Vuex
   */
  isAuthenticated() {
    return !!store.state.userAuthentified?.token;
  }

  /**
   * Obtenir le token actuel depuis Vuex
   */
  getToken() {
    return store.state.userAuthentified?.token || null;
  }
}

export default new AuthService();
